class MVisitorCounter extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      liveViews: [".m-product-live-views"],
      stockCountdowns: [".prod__stock-countdown"]
    };
  }

  connectedCallback() {
    this.init();
  }

  init() {
    try {
      if (typeof queryDomNodes === 'function') {
        this.domNodes = queryDomNodes(this.selectors);
      } else {
        const list = this.querySelectorAll ? Array.from(this.querySelectorAll('.m-product-live-views')) : [];
        if (this.classList && this.classList.contains('m-product-live-views')) {
          list.push(this);
        }
        this.domNodes = {
          liveViews: list,
          stockCountdowns: this.querySelectorAll ? Array.from(this.querySelectorAll('.prod__stock-countdown')) : []
        };
      }
      this.initLiveViews();
    } catch (e) {
      console.warn('MVisitorCounter init error:', e);
    }
  }

  initLiveViews() {
    if (this.domNodes && this.domNodes.liveViews) {
      this.domNodes.liveViews.forEach((e) => {
        if (e && e.dataset && e.dataset.initialized !== "true") {
          const textEl = e.querySelector(".live-views-text");
          const data = e.dataset;
          if (textEl && data.liveViewsCurrent) {
            const content = textEl.innerHTML;
            textEl.innerHTML = content.replace(
              data.liveViewsCurrent,
              `<span class="live-view-numb">${data.liveViewsCurrent}</span>`
            );
            this.changeLiveViewsNumber(textEl, data);
          }
          e.dataset.initialized = "true";
        }
      });
    }
  }

  changeLiveViewsNumber(textEl, data) {
    const numEl = textEl.querySelector(".live-view-numb");
    const { liveViewsDuration: s, liveViewsMax: n, liveViewsMin: o } = data;
    const r = Number(s) || 5;
    const c = Number(n) || 30;
    const l = Number(o) || 20;
    if (numEl) {
      setInterval(() => {
        const rand = Math.floor(Math.random() * (c - l + 1)) + l;
        numEl.textContent = rand;
      }, 1000 * r);
    }
  }
}

if (!customElements.get("m-visitiors-counter")) {
  customElements.define("m-visitiors-counter", MVisitorCounter);
}
